import { type PayerBase, type TransactionItemDetail, getUserName } from 'models';
import { useTranslation } from 'react-i18next';
import { AvatarWrapper, Text, useFormatPrice } from 'ui';
import { useUser } from 'features/auth';

type P = {
  transactionItem: TransactionItemDetail;
  user: PayerBase;
};

const UserSimpleContent = ({ transactionItem, user }: P) => {
  const { t } = useTranslation();
  const formatPrice = useFormatPrice();
  const { railsUserData: viewer } = useUser();

  return (
    <AvatarWrapper
      avatar={{ alt: t('userAvatarProfilePhoto', { name: getUserName(user) }), photo: user.profilePhoto?.url }}
      extra={<Text>{formatPrice({ value: transactionItem.amount })}</Text>}
      user={{ isViewer: user.id === viewer.id, name: getUserName(user) }}
    />
  );
};

export default UserSimpleContent;
